import { OrderDirection } from './../../Datatable/OrderDirection';
import { QueryItem } from './../../Tonnage/models/TonnageQueryModel';
import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import TonnageModel from "../../Tonnage/models/TonnageModel";
import CargoModel from '../../Cargo/models/CargoModel';
import { MarketingMatchingContactModel } from '../models/MarketingMatchingContactModel';

export interface MatchingQueryParam {
    lay: string,
    can: string,
    loadAreas: QueryItem[],
    disAreas: QueryItem[],
    dwtMin: number,
    dwtMax: number,
    tonnageDwt: number,
    excludedCountries: QueryItem[],
    excludedCompanies: QueryItem[],
    marketingMatching: boolean,
    orderBy: string,
    orderDirection: OrderDirection,
}

const MatchingApi = {
    MatchingTonnage(param: MatchingQueryParam) {
        return Api.post<MatchingQueryParam, BaseResponse<TonnageModel[]>>("/api/tonnage/Matching", param);
    },
    MatchingCargo(param: MatchingQueryParam) {
        return Api.post<MatchingQueryParam, BaseResponse<CargoModel[]>>("/api/cargo/Matching", param);
    },
    MatketingMatchingTonnage(param: MatchingQueryParam) {
        return Api.post<MatchingQueryParam, BaseResponse<MarketingMatchingContactModel[]>>("/api/tonnage/MarketingMatching", param);
    },
    MatketingMatchingCargo(param: MatchingQueryParam) {
        return Api.post<MatchingQueryParam, BaseResponse<MarketingMatchingContactModel[]>>("/api/cargo/MarketingMatching", param);
    },
};
export default MatchingApi;